<template>
  <div id="app">
		<BlockUI :message="loadingMessage" :url="loadingImage" v-if="showBlockUI"></BlockUI>
		
		<router-view class="animated"></router-view>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ClearCache } from "./components/utils/clear-cache/ClearCache";

export default {
  components: {
  },
  mounted(){
    ClearCache();
  },
  ready() {
    this.setLoading(false, "Please wait...");
  },
  methods: {
    ...mapActions(["setLoading"])
  },
  computed: {
    ...mapGetters(["showBlockUI", "loadingImage", "loadingMessage", "isLoggedIn"])
  },
  name: "app"
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// App.vue?13b24b58